import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { XeroConnectionStatus } from '../models/xero.models';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class XeroService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/api/xero`;

  /**
   * Get current connection status
   */
  getConnectionStatus(): Observable<XeroConnectionStatus> {
    return this.http.get<XeroConnectionStatus>(`${this.apiUrl}/auth/status`);
  }

  /**
   * Get Xero authorization URL
   * User will be redirected to this URL to authorize
   * After authorization, Xero redirects to backend callback
   * Backend processes and redirects to Angular /xero/callback route
   */
  getAuthUrl(): Observable<{ success: boolean; authUrl: string }> {
    return this.http.get<{ success: boolean; authUrl: string }>(`${this.apiUrl}/auth/connect`);
  }

  /**
   * Disconnect from Xero
   */
  disconnect(): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(
      `${this.apiUrl}/auth/disconnect`,
      {}
    );
  }

  /**
   * Manually refresh access token
   */
  refreshToken(): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(`${this.apiUrl}/auth/refresh`, {});
  }
}
